import React, {Component, ReactNode} from 'react'
import FacilitiesRepository from '../facilities/FacilitiesRepository'
import ReservationsRepository from './ReservationsRepository'
import HolidaysRepository from '../HolidaysRepository'
import NatRoomNumberRepo from '../../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatRidgeRepo from '../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import {
    FacilityReservation,
    ReservationOption,
    ReserveFacilityModel,
    ReserveFacilityModelDataSetObserver,
    ReserveFacilityModelUpdateReservationObserver,
} from './ReserveFacilityModel'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import styled from 'styled-components'
import {PlainLinkStyledBackButton, PrimaryStyledButton} from '../../styledComponents/Button'
import ResidentReserveFacilityForm from './ResidentReserveFacilityForm'
import {NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {Nullable} from '../../app/TypeHelpers'
import {SelectedUser} from '../../__NoAutomatedTests/components/common/resident/NatResidentSelectedUser'
import FacilityForReservation from '../facilities/FacilityForReservation'
import {HttpError} from '../../network/errors/HttpError'
import {Messages} from '../../Messages'
import {ErrorResponseBody} from '../../network/response/ErrorResponseBody'
import {DisplayItemDividerForPageTop} from '../../styledComponents/DisplayItem'
import {BlockSpacer} from '../../styledComponents/ResponsiveConvenience'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {MESSAGE_TYPE, RESERVATION_STATUS} from '../../CodeMaster'
import {RequestError} from '../../network/response/RequestError'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    facilityId: number
    reserveId: number
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    holidaysRepo: HolidaysRepository
    roomNumberRepo: NatRoomNumberRepo
    ridgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExResident
    reservationModel: ReserveFacilityModel
    currentDateTimeRepo: NatCurrentDateTimeRepo

    location: Location<LocationState>
}

interface LocationState {
    previousPageUrl: string
    errorResponseBody: Nullable<ErrorResponseBody>
    reserveInfo: Nullable<FacilityReservation>
}

interface State {
    isEnableToRegister: boolean
    errorResponseBody: Nullable<ErrorResponseBody>

    isLoadComplete: boolean
    reservationStartDate: Nullable<string>
    reservationStartTime: Nullable<string>
    reservationEndDate: Nullable<string>
    reservationEndTime: Nullable<string>
    reservationStayCount: Nullable<number>
    reservationTitle: Nullable<string>
    sharedUseRoomNumberList: SelectedUser[]
    reservationOptions: ReservationOption[]
}

class ResidentReserveFacilityUpdatePage extends Component<Props & ResidentPagePropsSet, State>
    implements ReserveFacilityModelDataSetObserver, ReserveFacilityModelUpdateReservationObserver {

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        props.reservationModel
            .addDataSetStateObserver(this)
            .addUpdateRentalFacilityReservation(this)

        this.state = {
            isEnableToRegister: false,
            errorResponseBody: null,
            isLoadComplete: false,
            reservationStartDate: null,
            reservationStartTime: null,
            reservationEndDate: null,
            reservationEndTime: null,
            reservationStayCount: null,
            reservationTitle: null,
            sharedUseRoomNumberList: [],
            reservationOptions: [],
        }

        this.handleOnClickReserveButton = this.handleOnClickReserveButton.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }


    async handleBackLinkOnClick(): Promise<void> {
        const {navigate, condominiumCd, facilityId, reserveId} = this.props
        const locationState: LocationState = this.props.location.state

        navigate(`/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reservations/${reserveId}/detail`, {
            replace: true,
            state: {
                previousPageUrl: locationState.previousPageUrl,
            },
        })
    }

    handleOnClickReserveButton(): void {
        this.props.reservationModel.build()
    }

    async onBuildUpdateRentalFacilityReservation(
        updateReservation: FacilityReservation,
        facilityData: FacilityForReservation,
    ): Promise<void> {
        const {condominiumCd, facilityId, reserveId, reservationsRepo, navigate, location} = this.props
        this.setState({
            errorResponseBody: null,
        }, async () => {
            await this.props.eventEmitter.showLoading()

            try {
                const returnValue = await NatAsyncCallFunction(
                    reservationsRepo.prepareUpdateFacilityReservation.bind(
                        reservationsRepo,
                        condominiumCd,
                        facilityId,
                        reserveId,
                        updateReservation,
                    ), navigate,
                )
                if (returnValue !== null) {
                    navigate(`/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reservations/${reserveId}/updateConfirm`, {
                        state: {
                            previousPageUrl: location.state.previousPageUrl,
                            stayAvailable: facilityData.stayAvailability,
                            facilityInfo: facilityData,
                            reserveInfo: updateReservation,
                        },
                    })
                }
            } catch (e) {
                const httpError: HttpError = e as HttpError
                this.setState({
                    errorResponseBody: {
                        ...httpError.responseBody,
                        requestError: {
                            ...httpError.responseBody.requestError,
                            title: Messages.EOPCR0002.toString('施設予約'),
                        },
                    },
                })
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        })
    }

    onDataSetStateChange(completeToCreate: boolean): void {
        if (this.state.isEnableToRegister === completeToCreate) {
            return
        }
        this.setState({isEnableToRegister: completeToCreate})
    }


    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {reserveId, navigate, condominiumCd, facilityId, location} = this.props

        try {
            const facilityReserve = await this.getFacilityReserve()

            if (facilityReserve === null) {
                return
            }

            if (facilityReserve.reserveStatus !== RESERVATION_STATUS.BEFORE_LOTTERY.value &&
                facilityReserve.reserveStatus !== RESERVATION_STATUS.ELECTION.value) {
                navigate(
                    `/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reservations/${reserveId}/detail`,
                    {
                        replace: true,
                        state: {
                            previousPageUrl: location.state.previousPageUrl,
                            errorResponseBody: new ErrorResponseBody(
                                new RequestError(
                                    '',
                                    '',
                                    Messages.EFACR0015.toString(),
                                    MESSAGE_TYPE.ERROR,
                                ),
                                [],
                            ),
                        },
                    },
                )
                return
            }

            this.props.reservationModel
                .withReservationId(reserveId)
                .withReserveType(facilityReserve.reserveType)
                .withReserveStatus(facilityReserve.reserveStatus)
                .withVersion(facilityReserve.version)

            let errorResponseBody: Nullable<ErrorResponseBody> = null
            if (this.props.location.state) {
                if (this.props.location.state.errorResponseBody !== undefined) {
                    errorResponseBody = this.props.location.state.errorResponseBody
                }
            }

            this.setState({
                    isLoadComplete: true,
                    reservationStartDate: facilityReserve.startDate,
                    reservationStartTime: facilityReserve.startTime,
                    reservationEndDate: facilityReserve.endDate,
                    reservationEndTime: facilityReserve.endTime,
                    reservationStayCount: facilityReserve.stayCount,
                    reservationTitle: facilityReserve.reservationTitle,
                    sharedUseRoomNumberList: facilityReserve.sharedUseRoomNumberList,
                    reservationOptions: facilityReserve.options,
                    errorResponseBody: errorResponseBody,
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return
    }

    async getFacilityReserve(): Promise<Nullable<FacilityReservation>> {

        if (this.props.location.state) {
            if ((this.props.location.state.reserveInfo !== undefined) &&
                (this.props.location.state.reserveInfo !== null)) {
                return this.props.location.state.reserveInfo
            }
        }

        const {condominiumCd, facilityId, reserveId, reservationsRepo, navigate} = this.props

        return await NatAsyncCallFunction(
            this.props.reservationsRepo.getFacilityReservation.bind(
                reservationsRepo,
                condominiumCd,
                facilityId,
                reserveId,
            ), navigate)
    }

    render(): ReactNode {
        const {reserveId} = this.props
        const {
            isLoadComplete,
            reservationStartDate, reservationStartTime, reservationEndDate, reservationEndTime,
            reservationStayCount, reservationTitle, reservationOptions, sharedUseRoomNumberList,
        } = this.state

        if (!isLoadComplete) {
            return null
        }


        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'15px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <ResidentReserveFacilityForm
                    reservationId={reserveId}
                    {...this.props}
                    eventEmitter={this.props.eventEmitter}
                    reservationStartDate={reservationStartDate}
                    reservationStartTime={reservationStartTime}
                    reservationEndDate={reservationEndDate}
                    reservationEndTime={reservationEndTime}
                    reservationStayCount={reservationStayCount}
                    reservationTitle={reservationTitle}
                    sharedUseRoomNumberList={sharedUseRoomNumberList}
                    reservationOptions={reservationOptions}
                    errorResponseBody={this.state.errorResponseBody}
                    renderSubmitButton={() =>
                        <ReserveButton
                            onClick={this.handleOnClickReserveButton}
                            disabled={!this.state.isEnableToRegister}>
                            予約内容を確認する
                        </ReserveButton>
                    }
                />
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentPage(ResidentReserveFacilityUpdatePage)

const ReserveButton = styled(PrimaryStyledButton)`
  margin-bottom: 1rem;
`
